module.exports = __webpack_public_path__ + "img/05c_Buy_651.7aeb8380.jpg";